// Mirrors the backend's CONFIG_DEFAULT (utils/constants/common.ts) - what the
// apps use for a setting the family never saved.
export const CONFIG_DEFAULT = {
  languageCode: 'en-US',
  brightness: 0.8,
  volume: 0.8,
  screenTimeout: 60,
  blockUnknownNumber: false,
  fallDetectionMessage: 'A fall is detected. Please act immediately',
  inactivityDetectionMessage: 'No movement detected. Please act immediately',
  thresholdLowBattery: 15,
  autoAnswerDelaySeconds: 3,
  alertRecipients: {
    fallAlertForSenior: false,
    fallAlertToAdmins: true,
    inactivityAlertForSenior: false,
    inactivityAlertToAdmins: true,
    lowBatteryAlertForSenior: true,
    lowBatteryAlertToAdmins: true,
    geofenceAlertForSenior: false,
    geofenceAlertToAdmins: true,
    noShowAlertForSenior: false,
    noShowAlertToAdmins: true,
  } as Record<string, boolean>,
};
